import initializeAccordion from '../components/accordion';
import initializeBurgerMenu from '../components/header';
import scrollTop from '../utils/scrollTop';

document.addEventListener('DOMContentLoaded', () => {
  initializeBurgerMenu();
  initializeAccordion('.single-career', '.career-item', '.career-item__title', '.career-item__content');
  scrollTop();
});